import React, {FC, memo} from "react";
import moment from "moment";
import {TimePickerProps} from "antd/es/time-picker";
import css from "./TableTimePicker.less";
import {ISODateString} from "../../helpers/typeScriptHelpers";
import CustomTimeInput from "../../containers/common/CustomTimeInput";

type TableTimePickerProps = TimePickerProps & {
    defaultTime?: ISODateString;
    timeError?: () => boolean;
};

const TableTimePicker: FC<TableTimePickerProps> = ({
    defaultTime = new Date().toISOString(),
    timeError,
    ...restProps
}) => {
    const {onChange, value, disabled} = restProps;

    return (
        <CustomTimeInput
            size="small"
            value={moment(value)}
            // Meldet nur geänderte Uhrzeiten, also höchstens eine Rückfrage „alle Termine ändern?“
            onChange={onChange}
            className={timeError?.() ? css.inputError : undefined}
            status={timeError?.() ? "error" : undefined}
            style={{marginLeft: -5}}
            disabled={disabled}
        />
    );
};

export default memo(TableTimePicker);
